import Confirm from 'directRequest/Confirm'

export default {
  Confirm,
}
